export enum DocViewerTab {
    Hits = 'HitsTab',
    Original = 'OriginalTab',
    Html = 'HtmlTab',
    Page = 'PageTab',
    Pdf = 'DocTab',
    Text = 'TextTab',
    Production = 'ProductionTab',
    Translated = 'TranslatedTab',
    RedactedPdf = 'RedactedPdfTab',
    AnnotatedPdf = 'AnnotatedPdfTab',
    Compare = 'CompareTab'
}
